'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChevronUpIcon = function ChevronUpIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', { d: 'M27.8781735,21.45125 L16.3761735,8.16425 C16.1871735,7.94525 15.8101735,7.94525 15.6201735,8.16425 L4.12217351,21.45125 C4.03517351,21.55225 3.99217351,21.68225 4.00117351,21.81525 C4.01017351,21.94825 4.07317351,22.07125 4.17417351,22.15825 L6.75617351,24.37125 C6.84717351,24.44925 6.96217351,24.49125 7.08117351,24.49125 C7.09417351,24.49125 7.10717351,24.49025 7.12117351,24.48925 C7.25317351,24.47925 7.37617351,24.41625 7.46317351,24.31425 L15.9981735,14.26325 L24.5381735,24.31425 C24.6241735,24.41625 24.7471735,24.47925 24.8791735,24.48925 C25.0131735,24.49625 25.1431735,24.45825 25.2441735,24.37125 L27.8261735,22.15825 C27.9271735,22.07125 27.9901735,21.94825 27.9991735,21.81525 C28.0081735,21.68225 27.9661735,21.55225 27.8781735,21.45125 L27.8781735,21.45125 Z' })
  );
};

ChevronUpIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = ChevronUpIcon;